var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 8.00008C0.667969 3.94999 3.95121 0.666748 8.0013 0.666748C12.0514 0.666748 15.3346 3.94999 15.3346 8.00008C15.3346 12.0502 12.0514 15.3334 8.0013 15.3334C3.95121 15.3334 0.667969 12.0502 0.667969 8.00008ZM8.0013 2.00008C4.68759 2.00008 2.0013 4.68637 2.0013 8.00008C2.0013 11.3138 4.68759 14.0001 8.0013 14.0001C11.315 14.0001 14.0013 11.3138 14.0013 8.00008C14.0013 4.68637 11.315 2.00008 8.0013 2.00008Z",
    fill: "#FDEE2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.594 6.27622C10.8543 6.53657 10.8543 6.95868 10.594 7.21903L7.76552 10.0475C7.50517 10.3078 7.08307 10.3078 6.82272 10.0475L5.4085 8.63325C5.14815 8.3729 5.14815 7.95079 5.4085 7.69044C5.66885 7.43009 6.09096 7.43009 6.35131 7.69044L7.29412 8.63325L9.65114 6.27622C9.91149 6.01587 10.3336 6.01587 10.594 6.27622Z",
    fill: "#FDEE2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleYellow);
export default __webpack_public_path__ + "static/media/check-circle-yellow.502995f46cad68c2f5a8e0b23a905045.svg";
export { ForwardRef as ReactComponent };